import throttle from '../utils/throttle';

class ScrollTrigger {
  constructor() {
    this.articleTopper = document.querySelector('.single .content-inner .topper');
    this.isFrontPage = document.querySelector('.front-page');
    this.homepageTakeoverTopper = document.querySelector('.js-homepage-takeover-topper');
    this.sidebar = document.querySelector('.js-sidebar');
    this.sidebarScrollable = document.querySelector('.sidebar__scrollable');
    this.waypoint = document.querySelector('#waypoint');
    this.observer = new IntersectionObserver(this.setSidebarScrollableClass.bind(this));
    this.initialize();
  }

  initialize() {
    if (this.articleTopper) {
      this.setArticleClass();
      window.addEventListener('scroll', throttle(this.setArticleClass.bind(this), 200));
    }

    if (this.isFrontPage) {
      this.setHomepageClass();
      window.addEventListener('scroll', throttle(this.setHomepageClass.bind(this), 200));

      if (this.homepageTakeoverTopper) {
        window.addEventListener('scroll', throttle(this.setSidebarClass.bind(this), 100));
      }
    }

    this.observer.observe(this.waypoint);
  }

  // Add class when user has scrolled past article topper
  setArticleClass() {
    const isScrolledPastTopper = window.scrollY > this.articleTopper.clientHeight;
    document.body.classList.toggle('scrolled-down', isScrolledPastTopper);
  }

  // Add class when user has scrolled halfway down the viewport height
  setHomepageClass() {
    const isBelowFold = window.scrollY > window.innerHeight / 2;
    document.body.classList.toggle('scrolled-down', isBelowFold);
  }

  // Add class when user has scrolled past half of the homepage takeover topper
  setSidebarClass() {
    const halfOfTopper = this.homepageTakeoverTopper.clientHeight / 2;
    const isScrolledPastTopper = window.scrollY > halfOfTopper;
    this.sidebar.classList.toggle('fade-in', isScrolledPastTopper);
  }

  setSidebarScrollableClass(entries) {
    if (!entries[0].isIntersecting) {
      this.sidebarScrollable.classList.add('scrolled-down');
      this.sidebar.classList.add('scrolled-down');
    } else {
      this.sidebarScrollable.classList.remove('scrolled-down');
      this.sidebar.classList.remove('scrolled-down');
    }
  }
}

export default ScrollTrigger;
